import type { Work } from "@/types";

export const worksList: Work[] = [
  {
    id: "w-1001",
    title: "长夜星河",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20palace%20drama%20poster%2C%20deep%20blue%20and%20gold%20color%20scheme%2C%20silhouette%20of%20a%20warrior%20under%20a%20starry%20night%20sky%2C%20cinematic%20lighting%2C%20moody%20atmosphere%2C%20luxurious%20textured%20background%2C%20high%20detail&width=600&height=900&seq=aa-work-cover-1001&orientation=portrait",
    rating: 9.2,
    region: "内地",
    year: 2024,
    genre: "古装",
    tags: ["权谋", "历史", "群像"],
    director: "陈砚舟",
    cast: ["顾长风", "沈昭", "苏怀瑾", "陆时雨"],
    releaseDate: "2024-09-12",
    duration: "45分钟 / 集",
    synopsis:
      "乱世将倾，少年星官意外窥见天命轨迹，被迫卷入朝堂与江湖的双重棋局。在星河之下的抉择里，他必须用最锋利的方式守护最柔软的人心。",
    heat: 98600,
    updatedAt: "2024-10-09",
  },
  {
    id: "w-1002",
    title: "都市浮生记",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20city%20life%20drama%20poster%2C%20business%20people%20walking%20through%20glass%20skyscraper%20lobby%2C%20cool%20blue%20grey%20tones%2C%20rainy%20night%20reflections%2C%20cinematic%20editorial%20photography%2C%20clean%20minimal%20composition&width=600&height=900&seq=aa-work-cover-1002&orientation=portrait",
    rating: 8.6,
    region: "内地",
    year: 2024,
    genre: "都市",
    tags: ["职场", "情感", "现实主义"],
    director: "林一诺",
    cast: ["周宁", "程雪", "梁思远", "白露"],
    releaseDate: "2024-08-01",
    duration: "40分钟 / 集",
    synopsis:
      "四段交错的都市人生，在同一栋写字楼里彼此擦肩。他们追逐成功，也在深夜重新定义什么才是值得。",
    heat: 82100,
    updatedAt: "2024-10-08",
  },
  {
    id: "w-1003",
    title: "山河剑心",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20landscape%20poster%2C%20lone%20swordsman%20standing%20on%20cliff%20above%20misty%20mountains%2C%20ink%20wash%20painting%20style%2C%20deep%20blue%20and%20warm%20orange%20accents%2C%20dramatic%20clouds%2C%20elegant%20chinese%20aesthetic&width=600&height=900&seq=aa-work-cover-1003&orientation=portrait",
    rating: 8.9,
    region: "内地",
    year: 2023,
    genre: "武侠",
    tags: ["江湖", "侠义", "成长"],
    director: "柳青崖",
    cast: ["傅寒山", "温瑶", "祁夜", "祝清音"],
    releaseDate: "2023-11-20",
    duration: "42分钟 / 集",
    synopsis:
      "山河破碎之际，一把断剑牵出二十年前的旧案。初入江湖的少年剑客，在恩怨与家国之间，终于读懂了剑心二字的分量。",
    heat: 76400,
    updatedAt: "2024-04-15",
  },
  {
    id: "w-1004",
    title: "迷雾追凶",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=suspense%20crime%20thriller%20drama%20poster%2C%20detective%20silhouette%20in%20foggy%20city%20alley%20at%20night%2C%20cold%20steel%20blue%20palette%2C%20single%20warm%20street%20lamp%2C%20tense%20moody%20cinematic%20atmosphere%2C%20high%20contrast&width=600&height=900&seq=aa-work-cover-1004&orientation=portrait",
    rating: 9.0,
    region: "内地",
    year: 2024,
    genre: "悬疑",
    tags: ["犯罪", "推理", "烧脑"],
    director: "秦岭",
    cast: ["江屿", "罗清", "许安然", "孟川"],
    releaseDate: "2024-07-18",
    duration: "48分钟 / 集",
    synopsis:
      "一桩尘封十五年的悬案重启，退休刑警与年轻法医组成临时搭档。迷雾之下，每一个看似无关的细节，都在指向同一个名字。",
    heat: 91200,
    updatedAt: "2024-10-05",
  },
  {
    id: "w-1005",
    title: "时光信箱",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20fantasy%20movie%20poster%2C%20vintage%20mailbox%20in%20golden%20hour%20sunlight%2C%20floating%20paper%20letters%20and%20warm%20bokeh%2C%20soft%20cream%20and%20amber%20tones%2C%20dreamy%20nostalgic%20mood%2C%20delicate%20composition&width=600&height=900&seq=aa-work-cover-1005&orientation=portrait",
    rating: 8.4,
    region: "内地",
    year: 2024,
    genre: "爱情",
    tags: ["奇幻", "治愈", "青春"],
    director: "苏晴",
    cast: ["夏未晚", "顾承泽", "叶知秋"],
    releaseDate: "2024-06-28",
    duration: "118分钟",
    synopsis:
      "女孩在老宅阁楼发现一只旧信箱，投进去的信会寄往十年前。一封封迟到的心意，能否改变那个夏天未说出口的告别？",
    heat: 68900,
    updatedAt: "2024-09-01",
  },
  {
    id: "w-1006",
    title: "逆光而行",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=inspirational%20sports%20drama%20movie%20poster%2C%20runner%20sprinting%20out%20of%20a%20dark%20tunnel%20into%20blazing%20backlight%2C%20warm%20orange%20sun%20rays%2C%20dynamic%20motion%2C%20gritty%20realistic%20texture%2C%20hopeful%20uplifting%20tone&width=600&height=900&seq=aa-work-cover-1006&orientation=portrait",
    rating: 8.7,
    region: "内地",
    year: 2023,
    genre: "励志",
    tags: ["剧情", "运动", "人生"],
    director: "徐向北",
    cast: ["穆野", "丁兰", "周小满"],
    releaseDate: "2023-12-08",
    duration: "126分钟",
    synopsis:
      "一场意外让短跑天才告别赛场，七年后他带着义肢重新站上起跑线。逆光而行的人，从未真正输给黑暗。",
    heat: 61200,
    updatedAt: "2024-02-11",
  },
  {
    id: "w-1007",
    title: "深海回响",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20deep%20sea%20disaster%20movie%20poster%2C%20submersible%20descending%20into%20dark%20trench%2C%20bioluminescent%20glowing%20creatures%2C%20deep%20teal%20and%20navy%20palette%2C%20eerie%20atmospheric%20lighting%2C%20cinematic%20scale%2C%20high%20detail&width=600&height=900&seq=aa-work-cover-1007&orientation=portrait",
    rating: 8.5,
    region: "内地",
    year: 2024,
    genre: "科幻",
    tags: ["灾难", "冒险", "视效"],
    director: "郑海生",
    cast: ["方承宇", "黎漾", "谭亦"],
    releaseDate: "2024-10-01",
    duration: "132分钟",
    synopsis:
      "深海科考队在马里亚纳海沟捕捉到一段规律信号。当潜艇下潜至万米，他们发现回响的来源，远比想象中更接近人类自己。",
    heat: 87400,
    updatedAt: "2024-10-10",
  },
  {
    id: "w-1008",
    title: "无名之辈·逆袭",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=action%20comedy%20heist%20movie%20poster%2C%20group%20of%20ordinary%20characters%20silhouette%20in%20city%20street%2C%20playful%20bold%20graphic%20style%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20energetic%20dynamic%20composition&width=600&height=900&seq=aa-work-cover-1008&orientation=portrait",
    rating: 8.2,
    region: "内地",
    year: 2024,
    genre: "喜剧",
    tags: ["动作", "黑色幽默", "群像"],
    director: "胡来",
    cast: ["马大勇", "钱多多", "孙小美", "赵铁柱"],
    releaseDate: "2024-05-20",
    duration: "110分钟",
    synopsis:
      "四个走投无路的小人物决定干一票大的，却把整个计划搞成了一场笑料百出的连锁意外。平凡如你我，也想赢一次。",
    heat: 55300,
    updatedAt: "2024-06-02",
  },
  {
    id: "w-1009",
    title: "星球探索者",
    type: "综艺",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20adventure%20reality%20show%20poster%2C%20diverse%20group%20of%20young%20travelers%20on%20mountain%20peak%20at%20sunrise%2C%20vibrant%20blue%20sky%20and%20warm%20sunlight%2C%20energetic%20documentary%20style%2C%20wide%20breathtaking%20landscape&width=600&height=900&seq=aa-work-cover-1009&orientation=portrait",
    rating: 8.0,
    region: "内地",
    year: 2024,
    genre: "户外",
    tags: ["竞技", "旅行", "真人秀"],
    director: "袁野",
    cast: ["常驻嘉宾团"],
    releaseDate: "2024-04-06",
    duration: "90分钟 / 期",
    synopsis:
      "六位嘉宾组成探索小队，穿越极地、雨林与峡谷。在真实自然的挑战里，他们比拼的不只是体力，还有信任与勇气。",
    heat: 47800,
    updatedAt: "2024-09-20",
  },
  {
    id: "w-1010",
    title: "声动人心",
    type: "综艺",
    cover:
      "https://readdy.ai/api/search-image?query=music%20competition%20reality%20show%20stage%20poster%2C%20singer%20silhouette%20under%20dramatic%20spotlight%2C%20deep%20blue%20stage%20with%20warm%20amber%20glow%2C%20concert%20smoke%20and%20light%20beams%2C%20elegant%20cinematic%20mood&width=600&height=900&seq=aa-work-cover-1010&orientation=portrait",
    rating: 8.3,
    region: "内地",
    year: 2023,
    genre: "音乐",
    tags: ["真人秀", "成长", "舞台"],
    director: "裴声",
    cast: ["新生代歌手群像"],
    releaseDate: "2023-09-15",
    duration: "100分钟 / 期",
    synopsis:
      "来自不同背景的素人歌者同台竞演，从无人问津到站上万人大舞台。每一次开嗓，都是一次与自己的和解。",
    heat: 49600,
    updatedAt: "2024-03-05",
  },
  {
    id: "w-1011",
    title: "春风十里报",
    type: "电视剧",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20family%20period%20drama%20poster%2C%20warm%20old%20town%20street%20in%20the%201990s%2C%20people%20cycling%20under%20spring%20blossoms%2C%20soft%20warm%20cream%20and%20amber%20tones%2C%20gentle%20sunlight%2C%20cozy%20storytelling%20mood&width=600&height=900&seq=aa-work-cover-1011&orientation=portrait",
    rating: 8.8,
    region: "内地",
    year: 2023,
    genre: "年代",
    tags: ["家庭", "温情", "成长"],
    director: "顾长宁",
    cast: ["何春生", "李秀兰", "何小满", "王建国"],
    releaseDate: "2023-06-10",
    duration: "44分钟 / 集",
    synopsis:
      "一条老街上，小满一家三代人的悲欢在春去秋来里静静流淌。平凡的日子，被热腾腾的烟火气写成了一首温柔的长诗。",
    heat: 63700,
    updatedAt: "2024-01-18",
  },
  {
    id: "w-1012",
    title: "暗涌之城",
    type: "电影",
    cover:
      "https://readdy.ai/api/search-image?query=neo-noir%20crime%20thriller%20movie%20poster%2C%20rain%20slick%20night%20city%20street%20with%20neon%20reflections%2C%20lone%20figure%20in%20long%20coat%2C%20deep%20blue%20and%20amber%20contrast%2C%20moody%20high%20contrast%20cinematography%2C%20mysterious%20atmosphere&width=600&height=900&seq=aa-work-cover-1012&orientation=portrait",
    rating: 8.6,
    region: "内地",
    year: 2024,
    genre: "犯罪",
    tags: ["悬疑", "剧情", "硬核"],
    director: "邱然",
    cast: ["高野", "秦岚钰", "方彻"],
    releaseDate: "2024-08-30",
    duration: "124分钟",
    synopsis:
      "经济寒冬下的海港城市暗流涌动，一名卧底警探在黑白边缘越陷越深。当身份开始模糊，他必须赌上一切守住最后的底线。",
    heat: 74500,
    updatedAt: "2024-09-28",
  },
];

export const regionOptions = ["全部", "内地", "港台", "欧美", "日韩"];
export const yearOptions = [
  "全部",
  "2024",
  "2023",
  "2022",
  "2021",
  "2020",
];
export const genreOptions = [
  "全部",
  "古装",
  "都市",
  "武侠",
  "悬疑",
  "爱情",
  "励志",
  "科幻",
  "喜剧",
  "犯罪",
  "年代",
  "户外",
  "音乐",
];